/* Copyright(c) 2020 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */
/** 
 *  @author Anshul Sarade 5671
    @fileName : QualityCustomizedLeadReport.js
    @Desc   : New UI for DC Customized Lead Report
 */

import React, { Component } from "react";
import Navigation from "../layouts/navPage";
import Footer from "../layouts/footer";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; //for authentication
import { saveAs } from "file-saver";
import "react-picky/dist/picky.css";
// import "./QualityCustomizedLeadReport.css";
import { Icon, Tooltip } from "antd";
import styled from "styled-components";
// below import added for downloading excel and zip files
import ExcelJS from "exceljs";
import JSZip from "jszip";
import "../campaign/loader.css";
import Picky from "react-picky";
import Select from "react-select";

const XLSX = require("xlsx");
const Swal = require("sweetalert2");

// htmltooltip

const HtmlTooltip = styled(Tooltip)`
     backgroundColor: '#f5f5f9',
     color: 'rgba(0, 0, 0, 0.87)',
     maxWidth: 220,
     fontSize: '12px',
     border: '1px solid #dadde9',
     `;

  //Anshul-5754: values for lead status filter
  const leadStatusOptions = [
  { id: "Delivered", name: "Delivered" },
  { id: "Review-Pending", name: "Review-Pending" },
  { id: "Accepted", name: "Accepted" },
  { id: "Rejected", name: "Rejected" },
];

class QualityCustomizedLeadReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      selectedOptions: [],
      filterValues: {},
      clientNames: [],
      campIDs: [],
      totalLeadCount: 0,
      loader: "",
      loader_progress: "",
      campaignLoader: "",
      selectedFields: [],
      // Anshul-5754: Adding new variables for storing the backend data
      leadStatus: [],
      allClientNames: [], 
      allCampIDs: [],  
      allUsers: [],    
      clientNames: [],
      campIDs: [],     
      users: [],       
      // end of adding new variables
      mandatoryFields: new Set([
        "Client Name",
        "Publisher ID",
        "Campaign ID",
        "Lead Interaction Date",
        "Last Name",
        "First Name",
        "Email",
        "Work Phone",
        "Company Name",
        "Industry",
        "Job Title",
        "Address",
        "City",
        "State",
        "Zip Code",
        "Country",
        "Asset Name",
        "Lead Info ID",
        "Lead Last Updated Date",
        "Lead Uploaded Date",
        "Lead Status",
      ]),

      // All  fields
      allFields: [
        "Client Name",
        "Publisher ID",
        "Campaign ID",
        "Campaign Name",
        "Allocation ID",
        "Lead Interaction Date",
        "Last Name",
        "First Name",
        "Email",
        "Work Phone",
        "Alternate Phone No",
        "LinkedIn",
        "Company Name",
        "LinkedIn Company Name",
        "Industry",
        "Company Employee Size",
        "Company Revenue",
        "Job Title",
        "LinkedIn Job Title",
        "Job Level",
        "Job Function",
        "Address",
        "Street",
        "City",
        "State",
        "Zip Code",
        "Country",
        "Asset ID",
        "Asset Name",
        "Domain",
        "Comments",
        "IP",
        "Extra 1",
        "Extra 2",
        "Extra 3",
        "Extra 4",
        "Extra 5",
        "Extra 6",
        "Extra 7",
        "Extra 8",
        "Extra 9",
        "Extra 10",
        "Extra 11",
        "Extra 12",
        "Extra 13",
        "Extra 14",
        "Extra 15",
        "Extra 16",
        "Extra 17",
        "Extra 18",
        "Extra 19",
        "Extra 20",
        "Extra 21",
        "Extra 22",
        "Extra 23",
        "Extra 24",
        "Extra 25",
        "Extra 26",
        "Extra 27",
        "Extra 28",
        "Extra 29",
        "Extra 30",
        "Email Status",
        "Address Link",
        "Device",
        "ESP Status",
        "ESP Name",
        "Internal QA",
        "Asset Sent By",
        "Contact Number Link",
        "DMA Name",
        "Reviewed by the Agency",
        "Reviewed by Quality",
        "Reviewed by DMA TL",

        "Lead Info ID",
        "Lead Last Updated Date",
        "Lead Uploaded Date",
        "Lead Status",
        "Reason", //Anshul-5754: added reason column in output file
      ],
    };
    this.dropdownRef = React.createRef();
    this.backButtonHandleChange = this.backButtonHandleChange.bind(this);
  }

  // fetchFilterOptions = (updatedFilterValues) => {
  //    //Nilesh-5733-Add loader
  //   this.setState({ loader_progress: "loader_campaign_list" });
  //   fetch("/qualityLeadRoute/filterOptions", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({ filterValues: updatedFilterValues }),
  //   })
  //     .then((res) => res.json())
  //     .then((data) => {
  //        this.setState({ loader_progress: "" }) //Nilesh-5733-Add loader
  //       const { filterValues } = this.state;

  //       const ensureSelectedInList = (list, selected) => {
  //         if (!selected || list.includes(selected)) return list;
  //         return [selected, ...list];
  //       };

        
  //       const ensureSelectedInListByCampID = (list, selectedCampID) => {
  //         if (!selectedCampID) return list;

  //         const found = list.some((item) => {
  //           const parts = item.split(" - ");
  //           return parts.length > 1 && parts[1] === selectedCampID;
  //         });

  //         return found ? list : [`${selectedCampID}`, ...list];
  //       };

  //       this.setState({
  //         clientNames: ensureSelectedInList(
  //           data.clientNames || [],
  //           filterValues["Client Name"]
  //         ),
  //         campIDs: ensureSelectedInListByCampID(
  //           data.campIDs || [],
  //           filterValues["Campaign ID"]
  //         ),

  //         users: ensureSelectedInList(data.users || [], filterValues["User"]),
  //       });
  //     })
  //     .catch((err) => {
  //       console.error("Error updating filter options:", err);
  //     });
  // };

  //Anshul-5754: updated below funcition due to filtered values are not shown properly
  fetchFilterOptions = (updatedFilterValues) => {
     //Nilesh-5733-Add loader
    this.setState({ loader_progress: "loader_campaign_list" });
    
   const shouldFilter = Object.keys(updatedFilterValues).length > 0;
  fetch("/qualityLeadRoute/filterOptions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ 
      filterValues: shouldFilter ? updatedFilterValues : {},
      shouldFilter: shouldFilter
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      this.setState({ loader_progress: "" });
      if (!shouldFilter) {
        this.setState({
          allClientNames: data.clientNames || [],
          allCampIDs: data.campIDs || [],
          allUsers: data.users || [],
          clientNames: data.clientNames || [],
          campIDs: data.campIDs || [],
          users: data.users || [],
        });
   } else {
this.setState(prevState => ({
  clientNames: data.clientNames || prevState.clientNames,
  campIDs: data.campIDs || prevState.campIDs,
  users: data.users || prevState.users,
}));
}

    })
    .catch((err) => {
      console.error("Error updating filter options:", err);
      this.setState({ loader_progress: "" });
    });
};

  toggleDropdown = () => {
    this.setState((prevState) => ({
      showDropdown: !prevState.showDropdown,
    }));
  };

  handleToggleSelectAll = (e) => {
    const { checked } = e.target;
    const { allFields, mandatoryFields } = this.state;

    const nonMandatoryFields = allFields.filter(
      (field) => !mandatoryFields.has(field)
    );

    this.setState({
      selectedFields: checked ? nonMandatoryFields : [],
    });
  };

  // end of selecting all fields
  backButtonHandleChange(e) {
    e.preventDefault();

    this.props.history.push("/qualityDashboard");
  }
  //end of backButtonHandleChange

  handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    this.setState(
      (prevState) => {
        let selectedOptions = [...prevState.selectedOptions];
        let filterValues = { ...prevState.filterValues };

        if (checked) {
          selectedOptions.push(value);
        } else {
          selectedOptions = selectedOptions.filter((item) => item !== value);

          if (value === "Date Range") {
            delete filterValues["Date Range From"];
            delete filterValues["Date Range To"];
          }
          // Anshul-5754:
          else if (value === "Lead Status") {
            delete filterValues["Lead Status"];
          }else {
            delete filterValues[value];
          }
        }

        return {
          selectedOptions,
          filterValues,
           ...(value === "Lead Status" ? { leadStatus: [] } : {}), //Anshul-5754: 
        };
      },
      () => {
        this.fetchFilterOptions(this.state.filterValues);
      }
    );
  };

  // handleFilterValueChange = (key, value) => {
  //   this.setState(
  //     (prevState) => ({
  //       filterValues: {
  //         ...prevState.filterValues,
  //         [key]: value,
  //       },
  //     }),
  //     () => {
  //       this.fetchFilterOptions(this.state.filterValues);
  //     }
  //   );
  // };

  //Anshul-5754: Updated the fuction due to filter value rendering issue
handleFilterValueChange = (key, value) => {
  this.setState(
    (prevState) => {
      const newFilterValues = {
        ...prevState.filterValues,
        [key]: value,
      };
      
      // For Client Name (multi-select), ensure it's always an array
      if (key === "Client Name" && !Array.isArray(value)) {
        newFilterValues[key] = value ? [value] : [];
      }
      
      return {
        filterValues: newFilterValues,
        // Reset other filter options when a filter changes
        ...(key !== "Client Name" ? { clientNames: prevState.allClientNames } : {}),
        ...(key !== "Campaign ID" ? { campIDs: prevState.allCampIDs } : {}),
        ...(key !== "User" ? { users: prevState.allUsers } : {}),
      };
    },
    () => {
      // Only fetch filtered options if we have at least one filter value
      const hasFilters = Object.values(this.state.filterValues).some(val => 
        val !== undefined && val !== null && val !== '' && 
        (!Array.isArray(val) || val.length > 0)
      );
      
      if (hasFilters) {
        this.fetchFilterOptions(this.state.filterValues);
      } else {
        // If no filters are selected, show all options
        this.setState({
          clientNames: this.state.allClientNames,
          campIDs: this.state.allCampIDs,
          users: this.state.allUsers,
        });
      }
    }
  );
};

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
  };

  //Nilesh-5733- removed unnecessary code
  // componentWillMount() {
  //   this.fetchFilterOptions({}); // Load all filter data initially
  // }

  //Anshul-5754: 
renderFilterInput = (filterKey) => {
  const { 
    filterValues, 
    clientNames = [], 
    campIDs = [], 
    users = [] 
  } = this.state;

  let placeholder = `Select ${filterKey}`;
  let selectOptions = [];

  if (filterKey === "Client Name") {
    selectOptions = clientNames.map(item => ({ value: item, label: item }));
    const selectedValue = Array.isArray(filterValues[filterKey])
      ? selectOptions.filter(opt => filterValues[filterKey].includes(opt.value))
      : [];

    return (
      <div style={{ width: "100%" }}>
        <Select
          isMulti
          options={selectOptions}
          isSearchable
          isClearable
          value={selectedValue}
          onChange={(selected) => {
            const value = selected ? selected.map((item) => item.value) : [];
            this.handleFilterValueChange(filterKey, value);
          }}
          placeholder="Select Client Name"
          styles={{
            control: (base) => ({
              ...base,
              minHeight: "34px",
              fontSize: "14px",
              fontFamily: "sans-serif",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 9999,
              maxHeight: "200px",
              overflowY: "auto",
            }),
          }}
        />
      </div>
    );
  } else if (filterKey === "User") {
    selectOptions = users.map(item => ({
      value: item,
      label: item,
    }));
    placeholder = "Lead Uploaded By";
  } else if (filterKey === "Campaign ID") {
    selectOptions = campIDs.map(item => {
      const parts = item.split(" - ");
      return {
        value: parts.length > 1 ? parts[1] : item,
        label: item,
      };
    });
    placeholder = "Select Campaign ID";
  }

  const selectedValue = Array.isArray(filterValues[filterKey])
    ? selectOptions.filter(opt => filterValues[filterKey].includes(opt.value))
    : selectOptions.find(opt => opt.value === filterValues[filterKey]);

  return (
    <div style={{ width: "100%" }}>
      <Select
        className="react-select__control_leadreport"
        options={selectOptions}
        isSearchable
        isClearable
        placeholder={placeholder}
        value={selectedValue || null}
        onChange={(selected) => {
          const value = selected ? selected.value : "";
          this.handleFilterValueChange(filterKey, value);
        }}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: "34px",
            fontSize: "14px",
            fontFamily: "sans-serif",
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          menuList: (base) => ({
            ...base,
            maxHeight: "200px",
            overflowY: "auto",
          }),
        }}
      />
    </div>
  );
};

  // Anshul-5754
  onLeadStatusHandleChange = (selected) => {
    this.setState((prevState) => ({
      leadStatus: selected,
      filterValues: {
        ...prevState.filterValues,
        "Lead Status": selected.map((item) => item.name),
      },
    }));
  };

  handleFieldChange = (field) => {
    this.setState((prevState) => {
      const selected = new Set(prevState.selectedFields);
      if (selected.has(field)) {
        selected.delete(field);
      } else {
        selected.add(field);
      }
      return { selectedFields: Array.from(selected) };
    });
  };
  handleDateChange = (type, value) => {
    this.setState({ [type]: value });
  };

  //Handle lead count
  handleSearchButton = () => {
    const { filterValues, selectedFields, mandatoryFields, selectedOptions } =
      this.state;
    const missingFields = [];

    for (const key of selectedOptions) {
      if (key === "Date Range") {
        const startDate = filterValues["Date Range From"];
        const endDate = filterValues["Date Range To"];
        if (!startDate || !endDate || new Date(startDate) > new Date(endDate)) {
          missingFields.push("Valid Date Range (Start and End Dates)");
        }
      } else {
        const value = filterValues[key];
        if (!value || value === key) {
          missingFields.push(key);
        }
      }
    }

    // below line to update the count to 0 when filter is applied
    this.setState({
      loader_progress: "loader_campaign_list",
      totalLeadCount: 0, //  reset count before making API call
    });

    fetch("/qualityLeadRoute/leadCount", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ filterValues }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error fetching count");
        return res.json();
      })
      .then((data) => {
        this.setState({ loader_progress: "" });

        if (data.leadCount === 0) {
          Swal.fire({
            type: "warning",
            title: "No records Found",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        } else {
          this.setState({ totalLeadCount: data.leadCount });
        }
      })
      .catch((err) => {
        console.error("Lead count fetch error:", err);
        this.setState({ loader_progress: "" });
      });
  }; // end of handle lead count

  //function added to download csv file
  createWorkbook = (rows) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet 1");

    if (rows.length > 0) {
      worksheet.columns = Object.keys(rows[0]).map((key) => ({
        header: key,
        key: key,
      }));
      worksheet.addRows(rows);
    }

    return workbook;
  };

  //handle download
  handleDownload = async () => {
    const { filterValues, mandatoryFields, selectedFields } = this.state;
    const mergedFields = Array.from(
      new Set([...mandatoryFields, ...selectedFields])
    );

    this.setState({ loader_progress: "loader_campaign_list" }, () => {
      setTimeout(async () => {
        try {
          const response = await fetch("/qualityLeadRoute/leadData", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filterValues,
              selectedFields: mergedFields,
            }),
          });

          // Check response type
          const contentType = response.headers.get("Content-Type") || "";

          if (!response.ok || !contentType.includes("application/json")) {
            this.setState({ loader_progress: "" });
            Swal.fire(
              "Error",
              "Unexpected response format. Please try again.",
              "error"
            );
            return;
          }

          const data = await response.json();

          const leads = data.results || [];

          if (leads.length === 0) {
            this.setState({ loader_progress: "" });
            Swal.fire("No Data", "No lead data found.", "info");
            return;
          }

          if (leads.length <= 20000) {
            const workbook = this.createWorkbook(leads);
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), "Lead_Report.xlsx");
          } else {
            const zip = new JSZip();
            const batches = Math.ceil(leads.length / 20000);

            for (let i = 0; i < batches; i++) {
              const batchData = leads.slice(i * 20000, (i + 1) * 20000);
              const workbook = this.createWorkbook(batchData);
              const buffer = await workbook.xlsx.writeBuffer();
              zip.file(`Lead_Batch_${i + 1}.xlsx`, buffer);
            }

            const zipBlob = await zip.generateAsync({ type: "blob" });
            saveAs(zipBlob, "Lead_Report.zip");
          }

          this.setState({ loader_progress: "" });

          Swal.fire({
            html: "Report downloaded successfully.",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } catch (err) {
          console.error("Error generating Excel:", err);
          this.setState({ loader_progress: "" });
          Swal.fire("Error", "Failed to download report", "error");
        }
      }, 100);
    });
  }; // end of handle download

  // Disabled the search button untill filter values does not selected
  isAllFiltersValid = () => {
    const { selectedOptions, filterValues } = this.state;

    if (selectedOptions.length === 0) return false;

    for (const key of selectedOptions) {
      if (key === "Date Range") {
        const start = filterValues["Date Range From"];
        const end = filterValues["Date Range To"];
        if (!start || !end || new Date(start) > new Date(end)) return false;
      } else {
        const val = filterValues[key];
        if (!val || val === key || val.length === 0) return false;
      }
    }

    return true;
  };

  



  fetchCampaignIDsFromDiqa = () => {
    const data = {
      startDate: this.state.filterValues["Date Range From"] || "",
      endDate: this.state.filterValues["Date Range To"] || "",
      campID: "",
    };

    fetch("/diQARole/diqaLeadsReport", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        const uniqueCampIDs = Array.from(
          new Set(result.map((item) => item.campID))
        ).filter((id) => id != null);

        this.setState({ campIDs: uniqueCampIDs });
      })
      .catch((err) => {
        console.error("Failed to fetch Campaign IDs from DIQA:", err);
      });
  };

  render() {
    const allFilterOptions = [
      "Campaign ID",
      "Client Name",
      "User",
      "Lead Status",  //Anshul-5754: 
      "Date Range",
    ];

    const {
      selectedOptions,
      showDropdown,
      allFields,
      mandatoryFields,
      selectedFields,
      totalLeadCount,
    } = this.state;

    return (
      <div>
        <Navigation />

        <div
          className=" customized-lead-container px-4"
          style={{ marginTop: "100px" }}
        >
          <div className="lead-report-header customized d-flex align-items-center mb-4 px-2">
            {/* back button - fixed on left */}
            <div style={{ minWidth: "65px" }}>
              <a
                href={"#/"}
                onClick={this.backButtonHandleChange}
                style={{ color: "#056eb8" }}
              >
                <FaArrowAltCircleLeft size={32} title="Back to Dashboard" />
              </a>
            </div>

            {/* title - centered */}
            <div className="flex-grow-1 text-center">
              <label
                id="labelDI"
                className="lead-report-title customized-title"
              >
                Customized Lead Report
              </label>
            </div>

            {/* empty div for balance - same width as back button */}
            <div style={{ minWidth: "65px" }}></div>
          </div>

          <div
            className="filter-card"
            style={{ padding: "20px", width: "100%" }}
          >
            <h5
              style={{
                color: "#F28C0F",
                fontFamily: "Roboto",
                fontSize: "16px",
                fontWeight: 500,
              }}
            >
              Input Fields For Report:
            </h5>

            <hr className="my-2" style={{ color: "lightgrey" }} />

            <div className="row align-items-start">
              <div className="col-md-4">
                <label
                  style={{
                    color: "#193D8f",
                    margin: 0,
                    whiteSpace: "nowrap",
                    minHeight: "20px",
                    borderRadius: "1px",
                    fontWeight: "500",
                    fontSize: "14px",
                  }}
                >
                  Select Input Filters<span style={{ color: "red" }}> *</span> :
                </label>

                <div
                  className="dropdown mt-2"
                  ref={this.dropdownRef}
                  style={{ position: "relative", marginLeft: "10px" }}
                >
                  <div
                    onClick={this.toggleDropdown}
                    style={{
                      padding: "8px 12px",
                      border: "1px solid #CCCCCC",
                      borderRadius: "3px",
                      backgroundColor: "#FFFFFF",
                      fontFamily: "sans-serif",
                      color: "#555555",
                      fontSize: "14px",
                      cursor: "pointer",
                      width: "100%",
                      minHeight: "36px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      minWidth: "170px",
                    }}
                  >
                    <span>
                      {selectedOptions.length === 0
                        ? "Select Filters"
                        : `${selectedOptions.length} out of 4 Filters Selected`}
                    </span>
                    <span style={{ fontSize: "10px", marginLeft: "10px" }}>
                      ⮟
                    </span>
                  </div>

                  {showDropdown && (
                    <div
                      className="dropdown-content"
                      style={{
                        position: "absolute",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        borderRadius: "5px",
                        zIndex: 1,
                        width: "100%",
                        maxHeight: "150px",
                        overflowY: "auto",
                        marginTop: "0px",
                      }}
                    >
                      {[
                        "Select All",
                        "Campaign ID",
                        "User",
                        "Client Name",
                        "Lead Status", //Anshul-5754
                        "Date Range",
                      ].map((option) => (
                        <label
                          key={option}
                          style={{
                            display: "block",
                            marginBottom: "5px",
                            color: "#495057",
                            fontWeight: "500",
                          }}
                        >
                          <input
                            style={{ cursor: "pointer" }}
                            type="checkbox"
                            value={option}
                            onChange={(e) => {
                              if (option === "Select All") {
                                const allOptions = allFilterOptions;
                                if (e.target.checked) {
                                  this.setState(
                                    {
                                      selectedOptions: allOptions,
                                    },
                                    () => {
                                      this.fetchFilterOptions(
                                        this.state.filterValues
                                      );
                                    }
                                  );
                                } else {
                                  this.setState(
                                    {
                                      selectedOptions: [],
                                      filterValues: {},
                                      leadStatus: [],//Anshul-5754
                                    },
                                    () => {
                                      this.fetchFilterOptions({});
                                    }
                                  );
                                }
                              } else {
                                this.handleCheckboxChange(e);
                              }
                            }}
                            checked={
                              option === "Select All"
                                ? selectedOptions.length ===
                                  allFilterOptions.length
                                : selectedOptions.includes(option)
                            }
                          />{" "}
                          {option}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* loader */}

              <div id={this.state.loader_progress}></div>

              {/* Filters */}
              <div className="col-md-8">
                {selectedOptions.length === 0 ? (
                  <div
                    style={{
                      color: "red",
                      fontWeight: 500,
                      fontSize: "16px",
                      marginTop: "13px",
                      //  marginLeft: "-170px",
                    }}
                  >
                    *Please select at least one filter to fetch data.
                  </div>
                ) : (
                  <>
                    <div
                      className="filter-card"
                      style={{
                        border: "0.2px solid #CCCCCC",
                        padding: "20px",
                      }}
                    >
                      <div className="custom-lead-filters row">
                        {selectedOptions.map((option) => {
                          if (option.toLowerCase() === "date range") {
                            return (
                              <React.Fragment key="date-range">
                                {/* Start Date */}
                                <div className="col-md-4 mb-2 d-flex align-items-center">
                                  <label
                                    style={{
                                      color: "#193D8f",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      marginRight: "8px",
                                    }}
                                  >
                                    Start Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    style={{ width: "100%" }}
                                    value={
                                      this.state.filterValues[
                                        "Date Range From"
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      this.handleFilterValueChange(
                                        "Date Range From",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>

                                {/* End Date */}
                                <div className="col-md-4 mb-2 d-flex align-items-center">
                                  <label
                                    style={{
                                      color: "#193D8f",
                                      fontWeight: "500",
                                      fontSize: "14px",
                                      whiteSpace: "nowrap",
                                      marginRight: "8px",
                                    }}
                                  >
                                    End Date:
                                  </label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    style={{ maxWidth: "180px" }}
                                    value={
                                      this.state.filterValues[
                                        "Date Range To"
                                      ] || ""
                                    }
                                    onChange={(e) =>
                                      this.handleFilterValueChange(
                                        "Date Range To",
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </React.Fragment>
                            );
                            // //Anshul-5754: 
                          } else if (option.toLowerCase() === "client name") {
  return (
    <div
      key={option}
      className="col-md-4 mb-2 d-flex align-items-center position-relative"
    >
      <label
        style={{
          color: "#193D8f",
          marginRight: "8px",
          fontWeight: "500",
          fontSize: "14px",
          whiteSpace: "nowrap",
        }}
      >
        {option}:
      </label>
      <div style={{ flex: 1 }}>
        <Picky
          value={this.state.filterValues["Client Name"] || []}
          options={this.state.clientNames}
          onChange={(selected) => {
            this.handleFilterValueChange("Client Name", selected);
          }}
          multiple={true}
          includeSelectAll={true}
          dropdownHeight={200}
          numberDisplayed={1}
          placeholder={"Select Client"}
          open={false}
          className={`pc-lead-report-PickyStyle`}
          style={{ minHeight: "33px", cursor: "pointer" }}
        />
      </div>
    </div>
  );
}
else if (option.toLowerCase() === "lead status") {
                            return (
                              <div
                                key={option}
                                className="col-md-4 mb-2 d-flex align-items-center position-relative"
                              >
                                <label
                                  style={{
                                    color: "#193D8f",
                                    marginRight: "8px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}:
                                </label>
                                <div style={{ flex: 1 }}>
                                  <Picky
                                    value={this.state.leadStatus}
                                    options={leadStatusOptions}
                                    onChange={this.onLeadStatusHandleChange}
                                    open={false}
                                    valueKey="id"
                                    labelKey="name"
                                    multiple={true}
                                    placeholder={"Select Status"}
                                    includeSelectAll={true}
                                    dropdownHeight={200}
                                    numberDisplayed={0}
                                    id="leadStatus"
                                    name="leadStatus"
                                    className={`pc-lead-report-PickyStyle`}
                                    style={{
                                      minHeight: "33px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          }
                           else {
                            return (
                              <div
                                key={option}
                                className="col-md-4 mb-2 d-flex align-items-center"
                              >
                                <label
                                  style={{
                                    color: "#193D8f",
                                    marginRight: "8px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {option}:
                                </label>
                                <div style={{ flex: 1 }}>
                                  {this.renderFilterInput(option)}
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn add-button action-button"
                          style={{ width: "90px" }}
                          onClick={() => this.handleSearchButton()}
                          disabled={!this.isAllFiltersValid()}
                          title={
                            !this.isAllFiltersValid()
                              ? "Please fill all selected filter values"
                              : ""
                          }
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {selectedOptions.length === 0 ? null : (
              <>
                <hr className="my-8" style={{ color: "lightgrey" }} />

                <div
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#F28C0F",
                    paddingLeft: "16px",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    marginLeft: "-10px",
                  }}
                >
                  Output Fields For Report :
                  <input
                    type="checkbox"
                    checked={allFields
                      .filter((field) => !mandatoryFields.has(field))
                      .every((field) => selectedFields.includes(field))}
                    onChange={this.handleToggleSelectAll}
                    style={{ cursor: "pointer" }}
                  />
                  <label
                    style={{
                      fontWeight: 400,
                      fontSize: "13px",
                      color: "black",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      marginTop: "6px",
                    }}
                  >
                    Select All
                  </label>
                  {/* tooltip */}
                  <HtmlTooltip
                    placement="right"
                    title={
                      <React.Fragment>
                        <li>
                          {
                            "The 'Select All' option will select all the listed fields below. Fields that are disabled are mandatory and cannot be unselected."
                          }
                        </li>
                      </React.Fragment>
                    }
                  >
                    <Icon type="question-circle" />
                  </HtmlTooltip>
                </div>

                <hr className="mt-1" style={{ color: "lightgrey" }} />

                <div
                  className="row"
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                    padding: "10px",
                    borderRadius: "1px",
                    marginBottom: "10px",
                  }}
                >
                  {allFields.map((field) => {
                    const isMandatory = mandatoryFields.has(field);
                    const isChecked =
                      isMandatory || selectedFields.includes(field);

                    return (
                      <div className="col-md-6 mb-2" key={field}>
                        <label
                          style={{
                            fontWeight: "normal",
                            color: isMandatory
                              ? "rgba(0, 0, 0, 0.41)"
                              : "rgba(0, 0, 0, 1)",
                            display: "block",
                            cursor: isMandatory ? "not-allowed" : "pointer",
                            opacity: 1,
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            disabled={isMandatory}
                            onChange={() => this.handleFieldChange(field)}
                            style={{
                              marginRight: "8px",
                              accentColor: "#0d6efd",
                              cursor: isMandatory ? "not-allowed" : "pointer",
                            }}
                          />
                          {field}
                        </label>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                >
                  <h5
                    style={{
                      color: "#F28C0F",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: 0,
                      marginRight: "10px",
                    }}
                  >
                    Total Lead Count: {totalLeadCount}
                  </h5>

                  <div className="row mt-3">
                    <div className="col d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn add-button action-button"
                        style={{ width: "90px" }}
                        onClick={this.handleDownload}
                        disabled={totalLeadCount <= 0}
                        title={
                          totalLeadCount <= 0
                            ? "No leads available to download"
                            : ""
                        }
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </div>
                <hr style={{ color: "lightgrey" }} />
              </>
            )}
          </div>
        </div>
    <Footer />
      </div>
    );
  }
}
QualityCustomizedLeadReport.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(QualityCustomizedLeadReport)
);
